<template>
  <div class="set-stage">
    
		<ul class="stages-list">
			<li
				v-for="(stage, index) in stages"
				:key="index"
				>
				
				<span>{{ stage }}</span>

				<Button
					v-if="thisCase.progress_stage != index"
					label="Set Stage"
					color="green"
					size="small"
					icon="bullseye" 
					@click="setStage(index)"
					/>
				<strong v-else>Current Stage</strong>

			</li>
		</ul>
  </div>
</template>

<script>

import Button from "@/Components/Button"

export default {
  props: [
    'thisCase'
  ],
  components: {
    Button
  },
  data: () => {
    return {
      stages: [
        'Enquiry Submission',
        'Image Submission',
        'Design Meeting',
        'Treatment Plan',
        'Implant Production',
				'Post Market Surveillance'
      ]
    }
  },
  mounted(){
    
  },
  methods: {
    setStage(index){
      this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/set-stage`, {
        stage: index
      })
    },
  }
}

</script>

<style scoped lang="sass">

.set-stage
	.stages-list
		list-style: none

		li
			display: flex
			align-items: center
			justify-content: space-between
			padding: 8px 0
			border-bottom: 1px solid rgba(#fff, 0.1)
			min-height: 60px

			&:last-child
				border-bottom: 0

			span
				font-size: 16px
				font-weight: 600
				color: #fff
				margin-right: 10px
				flex-grow: 1
				text-align: left

			strong
				font-size: 16px
				font-weight: 600
				color: #0d0
				margin-right: 10px
				text-align: right


</style>